export const setDataLayer = (event: string, data: Record<string, any>) => {
  let payload = {}

  if (event === 'profile' || event === 'portfolio') {
    const { artistName, artistId } = data
    payload = {
      event,
      'artist name': artistName,
      'artist id': artistId,
    }
  } else {
    payload = {
      event,
      ...data,
    }
  }

  window.dataLayer.push(payload)
}